import { NodeType, Schema } from 'prosemirror-model';

/**
 * Returns the NodeType from a schema given the NodeType or the name of the NodeType.
 * @param nodeTypeOrName The NodeType or the name of the NodeType.
 * @param schema The schema to get the NodeType from.
 * @returns The NodeType.
 */
export function getNodeType(nodeTypeOrName: NodeType | string, schema: Schema): NodeType {
  if (typeof nodeTypeOrName === 'string') {
    return schema.nodes[nodeTypeOrName];
  } else {
    return nodeTypeOrName;
  }
}
